import { BasketSummaryList } from './BasketSummaryList'

export const CheckoutBasketSummary = () => {
  const reload = () => {
    window.location.reload()
  }

  return <BasketSummaryList onRemove={reload} onEditFinished={reload} />
}
